import { Component } from 'react';
import './index.scss';
import { BrowserRouter as Router, Routes, Link, Route } from 'react-router-dom';
// import siteLogo from "../../assets/images/logo.svg";
import { ReactComponent as IconHome } from '../../assets/images/icons/iconHome.svg';
import CountdownTimer from '../CustomCounter';
import * as API from '../../configuration/apiconfig';

class Header extends Component {
  render() {
    var getCinemaIdFromLocalstorage = localStorage.getItem('cinemaid');
    let getLoginModule = JSON.parse(window.constant.SHOW_LOGGED_IN_USER_NAME);
    let checkGuestMessage = JSON.parse(window.constant.SHOW_WELCOME_GUEST);
    let firstName = API.getValueFromCookie('firstname');
    let lastName = API.getValueFromCookie('lastname');
    let fullName = firstName != null && lastName != null ? `${firstName} ${lastName}` : '';

    return (
      <>
        <header className="innerPageHeader">
          {this.props.logo && (
            <aside className="siteLogo">
              <a href="javascript:;">
                <img src={'/assets/images/logo.svg'} alt="Cinemas" className="img-fluid" width={window.constant.LOGO_WIDTH} height={window.constant.LOGO_HEIGHT} />
              </a>
            </aside>
          )}
          {getLoginModule && fullName != '' ? (
            <div className="user-logged">
              <p className="welcome-text">Welcome Back</p>
              <p className="logged-username">
                <img src={'/assets/images/user-icon.svg'} alt="User Icon" className="img-fluid" />
                {`${fullName.length > 20 ? fullName.substring(0, 20) + '...' : fullName}`}
              </p>
            </div>
          ) : checkGuestMessage && window.location.pathname != '/movies' && window.location.pathname != '/showtime' ? (
            <div className="user-logged">
              <p className="welcome-text">Hi,</p>
              <p className="logged-username">
                <img src={'/assets/images/user-icon.svg'} alt="User Icon" className="img-fluid" />
                Guest
              </p>
            </div>
          ) : null}
          {this.props.homeIcon && (
            <aside className="rightColumn">
              <Link to={`/?cinemaid=${getCinemaIdFromLocalstorage}`} className="homeButton" title="Go Home">
                {/* <img src={IconHome} alt="IconHome" className="img-fluid" /> */}
                <IconHome className="img-fluid" />
                <span>Go Home</span>
              </Link>
            </aside>
          )}
          {
            this.props.timer && <CountdownTimer hideGCModalBookingTimerElapse={this.props.hideGCModalBookingTimerElapse} />
            // <aside className="timer-blk" id="timer-sec">
            //   <span className="time-txt">Time left</span>
            //   <aside id="timer-counter" className="timer-count">__:__</aside>
            // </aside>
          }
        </header>
      </>
    );
  }
}

export default Header;
